import { html, nothing, TemplateResult } from "lit-html";

const SocialButtonsTemplate = ({ messages, captchaEnabled, socialLogin, handleSocialSubmit }: ISocialButtonsTemplate): TemplateResult => {
  return html`
  <div class="social-login-within-popup">
    <p class="social-intro">
      <span>${messages.SocialSubscriptionIntroText}</span>
    </p>
    <div class="social-login-box">
    ${socialLogin.facebook ? html`
    <div
        class="social-login-button social-login-facebook ts-facebook"
        @click=${handleSocialSubmit}
      >
        <i class="icon icon-facebook ts-facebook"></i>
      </div>
    ` : nothing}
    ${socialLogin.linkedin ? html`
    <div
        class="social-login-button social-login-linkedin ts-linkedin"
        @click=${handleSocialSubmit}
      >
        <i class="icon icon-linkedin ts-linkedin"></i>
      </div>
    ` : nothing}
    ${socialLogin.google ? html`
    <div
        class="social-login-button social-login-google ts-google"
        @click=${handleSocialSubmit}
      >
        <img class="icon-google ts-google" src="/static/img/icons/g-logo.png" />
      </div>
    ` : nothing}
    </div>
    ${captchaEnabled ? html`
    <div id="modal-social-captcha-container"></div>
    `: nothing}
    <p class="disclaimer">${messages.SocialSubscriptionDisclaimer}</p>
  </div>
  `;
}

export default SocialButtonsTemplate;